<template>
  <div class="template-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-form-item label="模板名称">
          <el-input v-model="queryParams.name" size="small" clearable placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="适用型号">
          <el-input v-model="queryParams.model" size="small" clearable placeholder="请输入适用型号"></el-input>
        </el-form-item>

          <el-button type="primary" size="small" round icon="el-icon-search" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
          <el-button style="margin-bottom: 10px;" type="primary" size="small" round icon="el-icon-circle-plus-outline"
                     @click="onClickAdd">新增
          </el-button>

      </el-form>

    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="uuid"
              show-overflow-tooltip
              align="center"
              label="模板ID">
          </el-table-column>
          <el-table-column
              prop="name"
              show-overflow-tooltip
              align="center"
              label="模板名称">
          </el-table-column>
          <el-table-column
              prop="model"
              show-overflow-tooltip
              align="center"
              label="适用型号">
          </el-table-column>
          <el-table-column
              prop="productModel"
              show-overflow-tooltip
              align="center"
              label="状态"
              width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status===1" type="success">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else type="info">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="创建时间">
          </el-table-column>
          <el-table-column label="操作" align="center" width="140">
            <template slot-scope="scope">
              <el-button
                  :loading="dialogTemplateEditLoading"
                  type="text" @click="onClickEdit(scope.row)">编辑
              </el-button>
              <el-button
                  v-if="scope.row.status===2||scope.row.status===0"
                  :loading="dialogTemplateLoading"
                  type="text"  @click="onClickPublish(scope.row)">发布
              </el-button>
              <el-button
                  v-if="scope.row.status===1"
                  :loading="dialogTemplateLoading"
                  type="text"  @click="onClickCannel(scope.row)">撤销
              </el-button>
              <el-button
                  v-if="scope.row.status===0||scope.row.status===2"
                  :loading="dialogTemplateLoading"
                  type="text"  @click="onClickDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="onChangeCurrent"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            :page-sizes="pageSizes"
            background
            layout="total, prev, pager, next,sizes"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <el-dialog
        class="dialog-code-box"
        append-to-body
        destroy-on-close
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogTemplateVisible"
        width="1000px">
      <div class="dialog-info-box">
        <el-tabs v-model="dialogTemplateActive" @tab-click="handleClick">
          <el-tab-pane label="产品信息" name="product"></el-tab-pane>
          <el-tab-pane label="操作说明" name="operate"></el-tab-pane>
        </el-tabs>
        <div>
          <div v-show="dialogTemplateActive==='product'">
            <el-form :model="dialogProductForm" :rules="dialogProductRule" ref="refDialogProduct"
                     label-position="top" label-width="auto">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="" prop="name">
                    <div style="display: flex;">
                      <div class="template-title template-icon">模板名称</div>
                      <el-input v-model="dialogProductForm.name" size="small"
                                style="width: 600px;" placeholder="请输入模板名称"></el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="" prop="model">
                    <div style="display: flex;">
                      <div class="template-title template-icon">适用型号</div>
                      <el-input v-model="dialogProductForm.model" size="small"
                                style="width: 600px;" placeholder="请输入通用型号"></el-input>
                      <div class="template-tips">注：不同型号用逗号隔开。</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <div class="template-title">产品宣传视频</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上传视频（或图片）" prop="productUrl">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogProductForm.productUrl"
                        :file-list="dialogProductVideoList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogProductVideoList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogProductVideoList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogProductVideoList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogProductVideoList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        视频规格200M以内
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                  <el-col :span="12">
                  <el-form-item label="上传视频封面图（图片类型忽略）" prop="productPic">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogProductForm.productPic"
                        :file-list="dialogProductImgList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogProductImgList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogProductImgList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogProductImgList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogProductImgList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        图片规格：650*365且不超过2M
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <div class="template-title">产品封面</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上传产品封面" prop="productInfoPic">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogProductForm.productInfoPic"
                        :file-list="dialogPproductInfoPicList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogPproductInfoPicList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogPproductInfoPicList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogPproductInfoPicList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogPproductInfoPicList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        视频规格200M以内
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="售后说明" prop="productContent" class="template-title">
                    <!--                    <vue-editor-->
                    <!--                        useCustomImageHandler-->
                    <!--                        @image-added="handleImageAdded"-->
                    <!--                        :disabled="dialogTemplateDisabled"-->
                    <!--                        v-model="dialogProductForm.productContent">-->
                    <!--                    </vue-editor>-->
                    <el-input v-model="dialogProductForm.productContent" size="small" clearable
                              :rows="3" type="textarea" placeholder="请输入售后说明"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-show="dialogTemplateActive==='operate'">
            <el-form :model="dialogOperateForm" :rules="dialogOperateRule" ref="refDialogOperate"
                     label-position="top" label-width="auto">
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="template-title">页面顶部视频</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上传视频（或图片）" prop="explanationUrl">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogOperateForm.explanationUrl"
                        :file-list="dialogOperateVideoList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogOperateVideoList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogOperateVideoList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogOperateVideoList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogOperateVideoList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        视频规格200M以内
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上传视频封面图（图片类型忽略）" prop="explanationPic">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogOperateForm.explanationPic"
                        :file-list="dialogOperateImgList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogOperateImgList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogOperateImgList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogOperateImgList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogOperateImgList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        图片规格：650*365且不超过2M
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="页面内容" prop="explanationContent" class="template-title">
                    <vue-editor
                        useCustomImageHandler
                        @image-added="handleImageAdded"
                        :disabled="dialogTemplateDisabled"
                        v-model="dialogOperateForm.explanationContent">
                    </vue-editor>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClickCodeCancel">取 消</el-button>
        <el-button v-if="!dialogTemplateDisabled" size="small" type="primary"
                   :loading="dialogTemplateLoading" @click="onClickCodeSubmit">提 交
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {
  deleteTranslationModel,
  getTemplateDetail,
  getTemplateList,
  sendTemplateAdd, sendTemplateDelete, sendTemplateUpdateStatus,
  single,
  updateTranslationModelStatus
} from "../../utils/interface";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      pageSizes: [10,20,50,100,500],
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      tableData: [],
      queryParams: {
        name: '',
        model: '',
        current: 1,
        pageSize: 10,
        total: 0,
      },
      enumStatus: [{
        value: 1,
        name: '已发布',
      }, {
        value: 0,
        name: '撤销',
      },{
        value: 2,
        name: '待发布',
      }],
      listLoading: false,
      dialogTemplateActive: 'product',
      dialogTemplateRow: {},
      dialogTemplateVisible: false,
      dialogTemplateDisabled: false,
      dialogTemplateLoading: false,
      dialogTemplateEditLoading: false,
      dialogProductVideoList: [],
      dialogProductImgList: [],
      dialogPproductInfoPicList:[],
      dialogProductForm: {
        uuid: "",
        name: "",
        model: "",
        productUrl: '',
        productPic: '',
        productInfoPic: '',
        productContent: '',
      },
      dialogProductRule: {
        name: [
          {required: true, message: '请输入模板名称', trigger: 'blur'},
        ],
        model: [
          {required: true, message: '请输入适用型号', trigger: 'blur'},
        ],
        productUrl: [
          {required: true, message: '请上传产品宣传视频', trigger: 'blur'},
          {required: true, message: '请上传产品宣传视频', trigger: 'change'},
        ],
        productPic: [
          {required: false, message: '请上传视频封面图', trigger: 'blur'},
          {required: false, message: '请上传视频封面图', trigger: 'change'},
        ],
        productInfoPic: [
          {required: false, message: '请上传产品封面图', trigger: 'blur'},
          {required: false, message: '请上传产品封面图', trigger: 'change'},
        ],
        productContent: [
          {required: true, message: '请输入售后说明', trigger: 'blur'},
        ],
      },
      dialogOperateVideoList: [],
      dialogOperateImgList: [],
      dialogOperateForm: {
        explanationUrl: '',
        explanationPic: '',
        explanationContent: '',
      },
      dialogOperateRule: {
        explanationUrl: [
          {required: true, message: '请上传产品宣传视频', trigger: 'blur'},
          {required: true, message: '请上传产品宣传视频', trigger: 'change'},
        ],
        explanationPic: [
          {required: false, message: '请上传视频封面图', trigger: 'blur'},
          {required: false, message: '请上传视频封面图', trigger: 'change'},
        ],
        explanationContent: [
          {required: true, message: '请输入页面内容', trigger: 'blur'},
        ],
      },
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      getTemplateList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    onClickAdd() {
      this.dialogTemplateVisible = true
      this.$nextTick(() => {
        this.dialogClearData()
      })
    },
    onClickEdit(row) {
      this.dialogTemplateEditLoading = true
      this.dialogTemplateRow = row
      getTemplateDetail(row.uuid).then((res) => {
        this.dialogTemplateEditLoading = false
        if (res.data) {
          let data = res.data
          this.dialogTemplateVisible = true
          this.$nextTick(() => {
            this.dialogClearData()
            this.dialogOperateForm = {
              explanationUrl: data.explanationUrl,
              explanationPic: data.explanationPic,
              explanationContent: data.explanationContent,
            }
            this.dialogProductForm = {
              uuid: row.uuid,
              name: data.name,
              model: data.model,
              productUrl: data.productUrl,
              productPic: data.productPic,
              productContent: data.productContent,
            }
            if (null!=data.productUrl&&data.productUrl!=''){
              this.dialogProductVideoList.push({name: 'file', url: data.productUrl})
            }
            if (null!=data.productPic&&data.productPic!=''){
              this.dialogProductImgList.push({name: 'file', url: data.productPic})
            }
            if (null!=data.explanationUrl&&data.explanationUrl!=''){
              this.dialogOperateVideoList.push({name: 'file', url: data.explanationUrl})
            }
            if (null!=data.explanationPic&&data.explanationPic!=''){
              this.dialogOperateImgList.push({name: 'file', url: data.explanationPic})
            }
            if (null!=data.productInfoPic&&data.productInfoPic!=''){
              this.dialogPproductInfoPicList.push({name: 'file', url: data.productInfoPic})
            }
          })
        }
      }).catch(err => {
        this.dialogTemplateEditLoading = false
      })
    },
    onClickPublish(row) {
      this.dialogTemplateLoading = true
      let data = {
        ...row,
        status: 1,
      }
      sendTemplateAdd(data).then((res) => {
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: '发布成功',
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickCannel(row) {
      // 撤回功能
      this.dialogTemplateLoading = true
      sendTemplateUpdateStatus(row.uuid,0).then((res) => {
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.message,
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickDelete(row){
      // 撤回功能
      this.dialogTemplateLoading = true
      sendTemplateDelete(row.uuid).then((res) => {
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success?"success" : "warning",
          message: res.message,
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        name: '',
        model: '',
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      // 在此刷新数据
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
    onClickCodeSubmit() {
      let that = this
      this.getDialogUpload('dialogProductVideoList', 'dialogProductForm', 'productUrl')
      this.getDialogUpload('dialogProductImgList', 'dialogProductForm', 'productPic')
      this.getDialogUpload('dialogOperateVideoList', 'dialogOperateForm', 'explanationUrl')
      this.getDialogUpload('dialogOperateImgList', 'dialogOperateForm', 'explanationPic')
      this.getDialogUpload('dialogPproductInfoPicList', 'dialogOperateForm', 'productInfoPic')

      that.$refs.refDialogProduct.validate((valid1) => {
        if (valid1) {
          that.$refs.refDialogOperate.validate((valid2) => {
            if (valid2) {
              that.dialogTemplateLoading = true
              let data = {
                ...that.dialogProductForm,
                ...that.dialogOperateForm,
                status: 0,
              }
              if (that.dialogTemplateRow && that.dialogTemplateRow.hasOwnProperty('uuid')) {
                data.uuid = that.dialogTemplateRow.uuid
              }
              sendTemplateAdd(data).then((res) => {
                that.dialogTemplateLoading = false
                that.onClickCodeCancel()
                that.$message({
                  type: res.success ? "success" : "warning",
                  message: '提交成功',
                })
                that.getPageList()
              }).catch(err => {
                that.dialogTemplateLoading = false
              })
            } else {
              that.$message.warning('请完善操作信息！')
              that.dialogTemplateActive = 'operate'
            }
          });
        } else {
          that.$message.warning('请完善产品信息！')
          that.dialogTemplateActive = 'product'
        }
      });
    },
    onClickCodeCancel() {
      this.dialogClearData()
      this.dialogTemplateVisible = false
    },
    getDialogUpload(key0, key1, key2) {
      if (this[key0].length) {
        let file0 = this[key0][0]
        if (file0.response) {
          this[key1][key2] = this[key0][0].response.url
        } else {
          this[key1][key2] = this[key0][0].url || ''
        }
      } else {
        this[key1][key2] = ''
      }
    },
    handleCardPreview(file) {
      this.dialogImgUrl = file.url
      this.dialogImgVisible = true
    },
    handleBeforeUpload(file, key) {
      let that = this
      if (key === 'dialogProductVideoList' || key === 'dialogOperateVideoList') {
        let isLtSize = file.size / 1024 / 1024 < 200
        if (!isLtSize) {
          this.$message.error('视频（或图片）大小不能超过 200MB!')
          return false
        }
        return true
      } else if (key === 'dialogProductImgList' || key === 'dialogOperateImgList') {
        let isLtSize = file.size / 1024 / 1024 < 2
        if (!isLtSize) {
          this.$message.error('视频（或图片）大小不能超过 2MB!')
          return false
        }

        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (curFile) => {
          const image = new Image()
          image.src = curFile.target.result
          image.onload = () => {
            const {width, height} = image
            if (width !== 650 || height !== 365) {
              this.$message.error("请上传 650*365 px 的图片！")
              that[key] = []
              return false
            } else {
              const isPNG = /^.png$/.test(file.name.substring(file.name.lastIndexOf('.')));
              const isJPG = /^.jpg$/.test(file.name.substring(file.name.lastIndexOf('.')));

              if (!(isPNG || isJPG)) {
                this.$message.error("图片只能是PNG或JPG格式!");
                that[key] = []
                return false
              } else {
                return true
              }
            }
          }
        }
      }
    },
    handleBusinessChange(file, fileList, key) {
      this[key] = fileList.slice(-1)
    },
    handleBusinessSuccess(response, file, fileList, key) {
      this[key] = fileList
    },
    handleBusinessRemove(file, fileList, key) {
      this[key] = fileList
    },
    handleClick(tab, event) {

    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData)
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      } else {
        alert("上传返回失败")
      }
    },
    dialogClearData() {
      this.dialogTemplateActive = 'product'
      this.dialogTemplateDisabled = false
      this.dialogTemplateLoading = false
      this.dialogTemplateRow = {}
      this.dialogProductVideoList = []
      this.dialogProductImgList = []
      this.dialogPproductInfoPicList = []
      this.dialogProductForm = {
        name: "",
        model: "",
        productUrl: '',
        productPic: '',
        productContent: '',
      }
      this.dialogOperateVideoList = []
      this.dialogOperateImgList = []
      this.dialogOperateForm = {
        explanationUrl: '',
        explanationPic: '',
        explanationContent: '',
      }
      this.$refs.refDialogProduct.resetFields()
      this.$refs.refDialogOperate.resetFields()
    },
  },
};
</script>

<style scoped lang="less">
.template-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}

/deep/ .el-dialog__body {
  padding: 0 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

/deep/ .el-dialog__header {
  padding: 5px;
}

/deep/ .template-title .el-form-item__label {
  white-space: nowrap;
  margin-right: 20px;
  color: black;
  font-weight: bold;
  font-size: 18px;
}

.template-title {
  white-space: nowrap;
  margin-right: 20px;
  color: black;
  font-weight: bold;
  font-size: 18px;
}

.template-icon:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
  font-weight: normal;
  font-size: 16px;
}

.template-tips {
  color: red;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoTemplateList.vue